import React from 'react'
import NotificationAutoInterUpdator from '../../../../NotificationAutoInterUpdator'
import { Link } from 'react-router-dom'
import NotificationViewModel from '../../../../NotificationViewModel'
import i18next from 'i18next'

const AddToBardNotif = (props) => {
  const { project } = props
  const lang = i18next.language
  const rtl = lang === 'ar'
  NotificationAutoInterUpdator(props)
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        rtl ? (
          <>
            لقد تمت إضافتك الى قائمة أعضاء مجلس الادارة بـ{' '}
            <Link
              to={`/projectProfile/${project?._id}`}
              style={{ fontWeight: 500, margin: 'auto 4px' }}
            >
              {project?.name}
            </Link>
          </>
        ) : (
          <>
            You have been added to the board members of{' '}
            <Link
              to={`/projectProfile/${project?._id}`}
              style={{ fontWeight: 500, margin: 'auto 4px' }}
            >
              {project?.name}
            </Link>
          </>
        )
      }
      buttonsArray={[]}
    />
  )
}

export default AddToBardNotif
